import axiosInstance from '@/shared/api/axios';
import type {
  ApiCargoIdDetail,
  ApiCargoIdLookupItem,
  ApiCargoIdLookupQueryResponse,
  ApiCargoIdParcelsListResponse,
  ApiCargoIdsListParams,
  ApiCargoIdsListResponse,
} from '@/shared/types/api/cargo-id';

export const apiCargoIdsAdminGet = async (
  params: ApiCargoIdsListParams,
): Promise<ApiCargoIdsListResponse> => {
  const { data } = await axiosInstance.get<ApiCargoIdsListResponse>('/cargo-ids/admin', { params });
  return data;
};

export const apiCargoIdAdminGet = async (id: string): Promise<ApiCargoIdDetail> => {
  const { data } = await axiosInstance.get<ApiCargoIdDetail>(`/cargo-ids/admin/${id}`);
  return data;
};

export const apiCargoIdParcelsGet = async (
  id: string,
  page: number,
): Promise<ApiCargoIdParcelsListResponse> => {
  const { data } = await axiosInstance.get<ApiCargoIdParcelsListResponse>(
    `/cargo-ids/admin/${id}/parcels`,
    { params: { page } },
  );
  return data;
};

export const apiCargoIdLookupByCode = async (code: string): Promise<ApiCargoIdLookupItem> => {
  const { data } = await axiosInstance.get<ApiCargoIdLookupItem>('/cargo-ids/admin/lookup', {
    params: { code },
  });
  return data;
};

export const apiCargoIdLookupByQuery = async (
  q: string,
  page: number,
): Promise<ApiCargoIdLookupQueryResponse> => {
  const { data } = await axiosInstance.get<ApiCargoIdLookupQueryResponse>(
    '/cargo-ids/admin/lookup',
    { params: { q, page } },
  );
  return data;
};
